import { module as BaseModule } from "modujs";

const SELECTORS = {
  open: "[data-promotional-banner-open]",
  close: "[data-promotional-banner-close]",
  panel: "[data-promotional-banner-panel]",
};

export default class PromotionalBanner extends BaseModule {
  init() {
    this.openButton = this.el.querySelector(SELECTORS.open);
    this.closeButtons = Array.from(
      this.el.querySelectorAll(SELECTORS.close)
    );
    this.panel = this.el.querySelector(SELECTORS.panel);

    if (!this.openButton || !this.panel) {
      return;
    }

    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);

    this.openButton.addEventListener("click", this.handleOpen);

    this.closeButtons.forEach((button) => {
      button.addEventListener("click", this.handleClose);
    });
  }

  destroy() {
    if (this.openButton) {
      this.openButton.removeEventListener("click", this.handleOpen);
    }

    this.closeButtons.forEach((button) => {
      button.removeEventListener("click", this.handleClose);
    });

    this.openButton = null;
    this.closeButtons = [];
    this.panel = null;
  }

  handleOpen() {
    this.el.classList.add("is-open");
    this.openButton.setAttribute("aria-expanded", "true");
    this.panel.hidden = false;
  }

  handleClose() {
    this.el.classList.remove("is-open");
    this.openButton.setAttribute("aria-expanded", "false");
    this.panel.hidden = true;
  }
}
